
import { defineComponent } from "vue";
import { EventInput } from "Models";

export default defineComponent({
  emits: ["update:modelValue"],
  props: {
    modelValue: {},
    modelModifiers: {
      default: () => ({}),
    },
    type: {
      type: String,
      default: "text",
    },
    isEditor: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    mask: {},
    borderClass: Object,
    placeholder: String,
    inputClass: Object,
    class: {
      type: String
    }
  },
  methods: {
    updateInput($event: EventInput) {
      this.$emit("update:modelValue", $event.target.value);
    },
  },
});
